import React from 'react';
import { Form } from 'semantic-ui-react';

/*
Props has:
  modeltype
  onChange
*/

class GSFInput extends React.Component {
  handleUpdate = this.handleUpdate.bind(this);

  handleUpdate(e,d) {
    d.value = {"TYPE" : "GSF_V.1.1.0",
               "FILE_NAME" : d.value};
    this.props.onChange(e,d);
  }

  getDefault(obj,name) {
    return obj[name] === undefined ? "" : obj[name];
  }

  render() {
    const {value} = this.props;
    return(
      <Form.Input inline name="GSF_FILE" label='GSF File'
                             value={this.getDefault(value, "FILE_NAME")}
                             onChange={this.handleUpdate} className='inlineFine' />
    )
  }
}

export default GSFInput;